import HttpService from "./htttp.service";

class EntityService {
  /**
   * Fetches entities for a given platform and date range.
   * @param {string} platform - The platform name (e.g., 'facebook').
   * @param {string} fromDate - Mandatory ISO date string (e.g., '2024-01-01').
   * @param {string} toDate - Mandatory ISO date string (e.g., '2024-01-31').
   * @param {string[]} [profileIds=[]] - Optional array of profile IDs.
   * @param {string} [id=""] - Optional entity ID.
   */
  async fetchEntity(platform, fromDate, toDate, profileIds = [], id = "") {
    if (!fromDate || !toDate) {
      throw new Error("Both 'fromDate' and 'toDate' are required.");
    }

    try {
      let endpoint = id
        ? `/platform/${platform.toLowerCase()}/entity/${id}`
        : `/platform/${platform.toLowerCase()}/entity`;

      const params = new URLSearchParams({ fromDate, toDate });

      if (!id && Array.isArray(profileIds) && profileIds.length > 0) {
        params.append("profile_ids", profileIds.join(","));
      }

      const url = `${endpoint}?${params.toString()}`;
      const response = await HttpService.get(url);
      return response;
    } catch (error) {
      console.error("Error fetching entities:", error);
      throw error;
    }
  }
}

export default new EntityService();
